module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("The Era 1947-1957")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "figure"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "triple",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tWhen the Yankees, the Giants, and the Dodgers Ruled the World")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n\tby Roger Kahn")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cfb4d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = 60
// module chunks = 0